import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { StockManagementState } from './StockManagementTypes'

const selectFeature = (state: State) => state.stockManagement

export const selectProduct = createSelector(
  selectFeature,
  (state: StockManagementState) => state.product,
)

export const selectProductTabsModelId = createSelector(
  selectFeature,
  (state: StockManagementState) => state.productTabs.filters.modelId,
)

export const selectProductBarcodes = createSelector(
  selectFeature,
  (state: StockManagementState) => state.productTabs.barcodes,
)

export const selectProductBarcodesLength = createSelector(
  selectFeature,
  (state: StockManagementState) => state.productTabs.barcodes.length,
)

export const selectProductMovements = createSelector(
  selectFeature,
  (state: StockManagementState) => state.productTabs.movements,
)

export const selectProductMovementsByType = createSelector(
  selectFeature,
  (state: StockManagementState) => state.productTabs.movementsByType,
)

export const selectProductReserves = createSelector(
  selectFeature,
  (state: StockManagementState) => state.productTabs.reserves,
)

export const selectHasProductMovementsNextPage = createSelector(
  selectFeature,
  (state: StockManagementState) => state.productTabs.movements.items.length
  < state.productTabs.movements.totalItems,
)

export const selectProductMovementPage = createSelector(
  selectFeature,
  (state: StockManagementState) => state.productTabs.movements.page,
)

export const selectProductTabFilters = createSelector(
  selectFeature,
  (state: StockManagementState) => state.productTabs.filters,
)

export default selectFeature
